// src/constants.js
export const CATEGORIES = ["Plumbing","Electrical","HVAC","Structural","Roofing","Flooring","Appliances","Exterior","Interior","Landscaping","Other"];
export const PRIORITIES = ["Low","Medium","High","Urgent"];
export const RECURRENCE = ["None","Weekly","Monthly","Quarterly","Bi-Annually","Annually"];

export const PRIORITY_COLORS = { Low:"#22c55e", Medium:"#f59e0b", High:"#f97316", Urgent:"#ef4444" };
export const PRIORITY_LIGHT = { Low:"#dcfce7", Medium:"#fef9c3", High:"#ffedd5", Urgent:"#fee2e2" };

export const CAT_ICONS = {
  Plumbing:"🔧", Electrical:"⚡", HVAC:"❄️", Structural:"🏗️",
  Roofing:"🏠", Flooring:"🪵", Appliances:"🔌", Exterior:"🌿",
  Interior:"🖼️", Landscaping:"🌱", Other:"🔨"
};

export const STORES = [
  { name:"Home Depot", color:"#F96302", url:"https://www.homedepot.com/s/" },
  { name:"Lowe's",     color:"#004990", url:"https://www.lowes.com/search?searchTerm=" },
  { name:"Menards",    color:"#00833d", url:"https://www.menards.com/main/search.html?search=" },
  { name:"Amazon",     color:"#FF9900", url:`https://www.amazon.com/s?tag=${process.env.REACT_APP_AMAZON_AFFILIATE_TAG}&k=` },
];

export const defaultTask = {
 title:"", category:"Other", priority:"Medium", notes:"",
 dueDate:"", recurrence:"None", completed:false, images:[],
 partsList:[], repairGuide:"",
};
